<template>
    <div class="pt-4">
       <div class="pb-4 pt-2 w-50 m-auto text-center" v-if="provider.name != ''"><img class="logo" style="width: 164px; height:auto; margin-top: -1rem" :src="provider.logo"></div>
        <div class="steps d-flex no-gutters w-50 mx-auto justify-content-center mt-1">
          <div class="bg-gray-300 border h-25 px-3 pt-1 rounded-pill active" style="font-size: 1.75em;">1</div>
          <div class="col-3 my-auto"><hr></div>
          <div :class="{active : step2 || step3}" class="bg-gray-300 border h-25 px-3 pt-1 rounded-pill bg-light" style="font-size: 1.75em;">2</div>
          <div class="col-3 my-auto"><hr></div>
          <div :class="{active : step3}" class="bg-gray-300 border h-25 px-3 pt-1 rounded-pill bg-light" style="font-size: 1.75em;">3</div>
        </div>
        <h2 class="card-title my-4 w-100 text-center peak-sans text-uppercase">
            {{sectionHeader}}
        </h2>
        <hr style="max-width: 750px">
        <div class='carousel-view'>
            <carousel :per-page="1" :mouse-drag="false" :navigate-to="currentPage"  :touchDrag="false" :pagination-enabled="false" ref="homeCarousel">
              <slide>
                  <ProviderSelection @providerChosen="setProvider"></ProviderSelection>
                   <div class="col-md-6 mx-auto">
                        <button class="btn btn-sm border text-dark d-block w-50 mx-auto" @click="goHome();">BACK</button>
                    </div>
              </slide>
              <slide class="slide">
                  <RebateFormComponent :provider="provider" ref="rebateForm"></RebateFormComponent>
                  <div class="col-md-6 mx-auto">
                    <button class="btn btn-sm border text-dark d-block w-50 mx-auto" @click="slideIt(0); setSteps(1);">BACK</button>
                  </div>
              </slide>
              <slide class="slide">
                  <RebateConfirmation ref="RebateConfirm"></RebateConfirmation>
              </slide>
              <slide class="slide">
                   <RebateEditComponent ref="RebateCheck" v-if="Object.keys(this.currentRebate).length  !== 0 "></RebateEditComponent>
                  <button class="btn btn-link d-block w-50 mx-auto" @click="slideIt(3)">Go Back and Enter a New Rebate</button>
              </slide>
            </carousel>
        </div>
    </div>
</template>

<script>
    import RebateFormComponent from './RebateFormComponent.vue';
    import RebateEditComponent from './RebateEditComponent.vue';
    import RebateCheckComponent from './RebateCheckComponent.vue';
    import RebateConfirmation from './RebateConfirmation.vue';
    import ProviderSelection from './ProviderSelection.vue';
    import { Carousel, Slide } from 'vue-carousel';

    import {mapState} from 'vuex';
import RebateStatusModalComponentVue from './RebateStatusModalComponent.vue';
    export default {
        name:"RebateSlider",
        mounted() {
            console.log('Component mounted.')
        },
        data() {
          return {
            sectionHeader:"Register with a qualified provider",
            amount:25.00,
            currentPage:0,
            provider:{
              name:'',
              logo:''
            },
            step2:false,
            step3:false,
            step4:false
          }
        },
        methods: {
            goHome(){
              this.$parent.goRebate();
            },
            slideIt(slide) {
              this.currentPage = slide;
            },
            previous () {
              const last = this.slides.pop()
              this.slides = [last].concat(this.slides)
            },
            setProvider (value) {
              console.log('provider is' + value.name)
              this.provider = value;
              this.setSteps(2);
              this.setRebateMeta(value);
            },
            setSteps(stepNum){
              let thisObj = this;
              $('.VueCarousel-wrapper').fadeOut(400,
              function(){
                console.log(stepNum);
                $("body,html").animate(
                {
                  scrollTop: $("#slider-container").offset().top
                },
                800 //speed
              );
                switch(stepNum){
                  case 1:
                    thisObj.sectionHeader ="Register with a qualified provider";
                    thisObj.step2 = false;
                    thisObj.step3 = false;
                    break;
                  case 2:
                    thisObj.slideIt(1);
                    thisObj.sectionHeader ="Submit Your Information";
                    thisObj.step2 = true;
                    thisObj.step3 = false;
                    break;
                  case 3:
                    thisObj.slideIt(2);
                    thisObj.sectionHeader ="Thanks for your submission!";
                    thisObj.step2 = false;
                    thisObj.step3 = true;
                    window.scrollTo({top:100, behavior:'smooth'});
                    break;
                case 4:
                    thisObj.slideIt(4);
                    thisObj.sectionHeader ="Edit your Submission";
                    thisObj.step2 = false;
                    thisObj.step3 = false;
                    thisObj.step4 = true;
                    window.scrollTo({top:100, behavior:'smooth'});
                    break;
                }
              }).slideDown(1000);
            },
            setRebateMeta(value){
                if (value.name) {
                    switch (value.name) {
//////////////////////////
//////////$75 Rebates/////
//////////////////////////
                        // case 'REV (EATEL Westside)':
                        // case 'REV (EATEL)':
                        // case 'REV (Reserve Telecommunications)':
                        // case 'REV (Vision Communications)':
                        // case 'NDTC (North Dakota Telephone Company)':
                        // case 'Antietam Cable Television':
                        // case 'Armstrong':
                        // case 'Comporium':
                        // case 'EPB Fiber Optics':
                        // case 'Fidelity Communications':
                        // case 'GVTC Communications':
                        // case 'Hargray':
                        // case 'HBC':
                        // case 'HTC Digital Cable':
                        // case 'Long Lines':
                        // case 'Mediacom':
                        // case 'MetroNet':
                        // case 'Orbitel Communications':
                        // case 'Service Electric Cable TV Hunterdon':
                        // case 'Service Electric Cable TV Lehigh Valley':
                        // case 'Service Electric Cable TV Wilkes Barre':
                        // case 'Shentel':
                        // case 'Skitter TV':
                        // case 'Sparklight':
                        // case 'WesTel Systems':
                        // case 'Ziply Fiber':
                        //     this.$refs.rebateForm.rebate.amount = 75.00
                        //     this.$store.commit('SET_BILLSREQUIRED', 6)
                        //     break;
//////////////////////////
//////////$50 Rebates/////
//////////////////////////
                        case 'DirecTV':
                        case 'DirecTV Stream':
                        case 'U-verse':
                            this.$refs.rebateForm.rebate.amount = 50.00
                            this.$store.commit('SET_BILLSREQUIRED', 3)
                            break;
//////////////////////////
//////////$25 Rebates/////
//////////////////////////
                        default:
                            this.$refs.rebateForm.rebate.amount = 25.00
                            this.$store.commit('SET_BILLSREQUIRED', 3)
                    }
                    // (value.name == 'DirecTV' || value.name == 'DirecTV Stream' || value.name == 'U-verse')) {
                    //     this.$refs.rebateForm.rebate.amount = 75.00
              } else {
                  this.$refs.rebateForm.rebate.amount = 25.00
              }
            }
          },
          watch:{
            currentRebate(){
                this.$refs.RebateConfirm.confirmed = true;
                this.$refs.RebateConfirm.setData(this.currentRebate);
                this.setSteps(3);
              },
            sliderStep:function(newval, oldval){
                this.setSteps(4);
            }
          },
          computed:{
            ...mapState(['currentRebate']),
            sliderStep(){
                return this.$store.state.sliderStep;
            }
          },

          components: {
            RebateFormComponent,
            RebateEditComponent,
            RebateCheckComponent,
            RebateConfirmation,
            ProviderSelection,
            Carousel,
            Slide
          }
    }
</script>
<style lang="scss">
.steps {
  .active{
    background:#444 !important;
    color:white;

  }
}
.VueCarousel-inner{
  flex-basis:100% !important;
}
</style>
